module.exports = __webpack_public_path__ + "img/highest.aec78948.svg";